module.exports = __webpack_public_path__ + "img/paly-end.1bbb550f.svg";